<template>
    <div>
        <p class="font-semibold cursor-pointer text-primary hover:font-semibold hover:underline"
           @click.stop="showDetailsEmployee" v-if="rowData.employee">{{
                checkEmployeeAnswer(rowData.employee)
            }}</p>
        <vs-popup class="holamundo" title="Thông tin nhân sự" fullscreen :active.sync="popupDetailsEmployee" v-if="popupDetailsEmployee">
            <EmployeeInformation :employeeId="getEmployeeId(rowData.employee)" :branch_id="getBranchId(rowData.employee)"></EmployeeInformation>
        </vs-popup>
    </div>
</template>

<script>
import EmployeeInformation from "@/views/user-pages/hrm-module/employee/EmployeeInformation";

export default {
    name: "CellRendererEmployee",
    props: {
        rowData: {
            type: Object,
            required: true,
        },
    },
    components: {
        EmployeeInformation
    },
    data() {
        return {
            popupDetailsEmployee: false,
        }
    },
    computed: {
        checkEmployeeAnswer() {
            return value => {
                if (value[0].employee) {
                    return value[0].employee.fullName;
                } else {
                    let employee = value.find(el => el.disposition == 'ANSWER');
                    if (employee) return employee.user.fullName;
                    return null
                }
            }
        },
        getEmployeeId() {
            return value => {
                if (value[0].employee) {
                    return value[0].employee.id;
                } else {
                    let employee = value.find(el => el.disposition == 'ANSWER');
                    if (employee) return employee.user.id;
                    return null
                }
            }
        },
        getBranchId() {
            return value => {
                if (value[0].employee) {
                    return value[0].employee.organizationBranchId;
                } else {
                    let employee = value.find(el => el.disposition == 'ANSWER');
                    if (employee) return employee.user.organizationBranchId
                    return null
                }
            }
        }
    },

    methods: {
        showDetailsEmployee() {
            this.popupDetailsEmployee = true;
        },
    }
}
</script>

<style scoped>

</style>
